export const FETCH_PLATFORM_SETTINGS_PUBLIC = 'FETCH_PLATFORM_SETTINGS_PUBLIC';
export const FETCH_PLATFORM_SETTINGS_ADMIN = 'FETCH_PLATFORM_SETTINGS_ADMIN';
export const UPDATE_PLATFORM_SETTINGS = 'UPDATE_PLATFORM_SETTINGS';
